<template>
   <v-navigation-drawer
    v-if="isAuthenticated"
    v-model="drawerValue"
    app
    clipped>
      <v-list dense class="pt-0">
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.route"
        >

          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'navigationDrawer',
  data () {
    return {
      drawerValue: true,
      items: [
        { title: 'Upload Pages', icon: 'mdi-application', route: '/' },
        { title: 'Connections', icon: 'mdi-power-plug', route: '/connections' }
      ]
    }
  },
  computed: {
    /*
    drawerValue: {
      get () {
        return this.$store.getters.getDrawer
      },
      set (val) {
        this.$store.commit('setDrawer', val)
      }
    }, */
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>

<style>

</style>
